import { useState } from "react"

const BenefitIcon = () => (
  <span className="inline-flex h-8 w-10 shrink-0 items-center justify-center rounded-md bg-[#ed860f] text-white shadow-sm sm:h-9 sm:w-12">
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" aria-hidden="true">
      <path
        d="M20 12a8 8 0 0 1-14.8 4.2M4 12A8 8 0 0 1 18.8 7.8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M5 17H2v-3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M19 7h3v3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  </span>
)

export default function Benefits({
  title,
  desc,
  items = [],
  image,
  imageAlt = "",
}) {
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <section className="bg-white pt-14 sm:pt-16 lg:pt-20">
      <div className="mx-auto w-full max-w-[1490px] px-5 pb-8 text-center sm:px-8 sm:pb-10 lg:px-12 xl:px-20">
        <h2 className="text-3xl font-bold text-black sm:text-4xl lg:text-[42px]">
          {title}
        </h2>

        {desc ? (
          <p className="mx-auto mt-4 max-w-[780px] text-sm leading-relaxed text-gray-600 sm:text-[15px]">
            {desc}
          </p>
        ) : null}
      </div>

      <div className="w-full">
        {items.map((item, index) => {
          const isActive = index === activeIndex
          const activeImage = item.image || image
          const activeImageAlt = item.imageAlt || imageAlt

          return (
            <article
              key={`${item.number}-${item.title}`}
              tabIndex={0}
              onMouseEnter={() => setActiveIndex(index)}
              onFocus={() => setActiveIndex(index)}
              onClick={() => setActiveIndex(index)}
              className={`cursor-pointer transition-colors duration-300 focus:outline-none ${isActive ? "bg-[#fff7ef]" : "bg-white"
                }`}
            >
              <div className="mx-auto grid w-full max-w-[1360px] gap-5 border-b border-black/25 px-5 py-9 sm:px-8 lg:min-h-[230px] lg:grid-cols-[190px_minmax(0,1fr)_430px] lg:items-center lg:gap-0 lg:px-10 xl:grid-cols-[220px_minmax(0,1fr)_500px] xl:px-0">
                <div className="text-[58px] font-bold leading-none text-transparent [-webkit-text-stroke:1.35px_#ed860f] sm:text-[72px] lg:text-[86px]">
                  {item.number}
                </div>

                <div className="max-w-[520px]">
                  <BenefitIcon />

                  <h3 className="mt-4 text-xl font-bold leading-tight text-black sm:text-[22px]">
                    {item.title}
                  </h3>

                  <p className="mt-4 text-sm leading-relaxed text-gray-700 sm:text-[15px]">
                    {item.desc}
                  </p>
                </div>

                {isActive && activeImage ? (
                <div
  key={activeImage}
  className="benefit-image-reveal overflow-hidden rounded-lg bg-white shadow-md lg:justify-self-end"
>
                    <img
                      src={activeImage}
                      alt={activeImageAlt}
                      className="h-[210px] w-full bg-white object-contain object-center p-6 transition-transform duration-500 hover:scale-105 sm:h-[250px] sm:p-8 lg:h-[190px] lg:w-[430px] lg:p-6 xl:h-[210px] xl:w-[500px] xl:p-8"
                    />
                  </div>
                ) : (
                  <div className="hidden lg:block" />
                )}
              </div>
            </article>
          )
        })}
      </div>
    </section>
  )
}